import * as React from 'react';
import { Group } from '@visx/group';
import { useCanvas } from '../../components/Canvas';
import { generatePath } from '../utils';
export function MiniBarGraph(_a) {
    var series = _a.series, accessors = _a.accessors, scalesMap = _a.scalesMap, barHeight = _a.barHeight, fill = _a.fill;
    var boundedWidth = useCanvas().boundedWidth;
    var _b = React.useMemo(function () {
        var data = accessors.data(series);
        var _a = scalesMap[accessors.key(series)], xScale = _a.xScale, yScale = _a.yScale;
        return {
            data: data,
            xScale: xScale,
            yScale: yScale
        };
    }, [series, accessors, scalesMap]), data = _b.data, xScale = _b.xScale, yScale = _b.yScale;
    var path = React.useMemo(function () {
        return generatePath({
            data: data,
            xScale: xScale,
            yScale: yScale,
            yMax: barHeight,
            accessors: accessors
        });
    }, [data, xScale, yScale, barHeight, accessors]);
    return (React.createElement(Group, null,
        React.createElement("path", { d: path, fill: fill }),
        React.createElement("rect", { width: boundedWidth, height: 1, y: barHeight, fill: fill })));
}
//# sourceMappingURL=MiniBarGraph.js.map